import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import './ValidatedFail.scss';
import HeaderValidation from '../../Dashboard/Visitor/External/Components/HeaderValidation';
import {IconLogoIEntryComplete} from '../../../components/buttons/IconButtons';
import ContainerValidation from '../../Dashboard/Visitor/External/Components/ContainerValidation';
import BodyValidation from '../../Dashboard/Visitor/External/Components/BodyValidation';
import routes from '../../../Routes/routes';
import {getUrlParameters} from "../../Dashboard/Visitor/External/Model/Model";
import ValidatedFailBody from "../../Dashboard/Visitor/External/ValidatedFailBody";
import {GetInvitationById} from "../../../reduxToolkit/Invitation/InvitationApi";
import {useDispatch} from "react-redux";
import {getMainUrl} from "../Model/Models";

const ValidatedFail = () => {
    const { id, guardFlowId, userId, eventId, buildingId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const failedUrl = buildingId
        ? getMainUrl({ userId, buildingId })
        : eventId
            ? getUrlParameters({ url: routes.eventDetails.findMySelf, id: eventId})
            : getUrlParameters({ url: routes.invitationDetails.registrationProcess, id, guardFlowId});

    return (
        <>
            <ContainerValidation>
                <HeaderValidation
                    showBtnBack={false}
                    headerCenter={<IconLogoIEntryComplete className={'icon-color-primary-800'} height={30} />}
                />
                <BodyValidation
                    showBtnNext={false}
                    showBtnPrev={true}
                    showLogoFooter={false}
                    className="identity-invitation-body"
                    classWith="content-center-w-800px gap-2"
                    clickPrev={() => {
                        if(eventId || buildingId){
                            navigate(failedUrl);
                            return;
                        }
                        dispatch(GetInvitationById(id)).then(({ payload :{data:{ success } }})=>{
                            if (success) {
                                navigate(failedUrl);
                            }
                        });
                    }}
                >
                    <ValidatedFailBody title={"identity_validation_failed"}/>
                </BodyValidation>
            </ContainerValidation>

        </>
    );
};

export default ValidatedFail;
